import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/shared/model/page/page-request';
import { PageResult } from 'src/app/shared/model/page/page-result';
import { Courier } from 'src/app/shared/model/courier';
import { HttpUtils } from 'src/app/shared/services/common/http-utils';
import { County } from 'src/app/shared/model/county';
import { BaseFilter } from 'src/app/shared/model/filter/base-filter';

@Injectable({
  providedIn: 'root',
})
export class CountyService {

  constructor(private readonly http: HttpClient) { }

  findCounties(countryCode: string, pageRequest: PageRequest): Observable<PageResult<County>> {
    const httpParams = HttpUtils.createHttpParams(pageRequest);
    return this.http.get<PageResult<County>>(`api/countries/${countryCode}/counties`, { params: httpParams });
  }

}
